import React, { Component } from 'react'
import { Card, Form, Row, Collapse } from 'react-bootstrap';
import { isNullOrUndefined } from 'util';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DATE_TIME_FORMAT, MAXNUMBER_OF_CHOICES, CHOICES, VOTES} from '../../../utils/constants';
import moment from 'moment';
import { FaPlus, FaMinus } from 'react-icons/fa';

class PollSelectionResult extends Component {

    constructor(props) {
        super(props)
        this.state = {
            currentChoiceList: [],
            activeSelection: null,
            activeChoice: null,
            selectionList: [],
            choiceList: [],
            pollDetails: props.pollDetails,
            emptyFlag: false,
            currentSelection: props.selections,
            imageFile: null,
            mode: props.mode,
            donePoll: false,
            showCollapse: true
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            selectionList: newProps.selections,
            pollDetails: newProps.pollDetails,
            currentSelection: newProps.selections,
            mode: newProps.mode
        })
    }

    componentDidMount() {

        let pollDetails = this.state.pollDetails
        let now = moment().format(DATE_TIME_FORMAT)
        if (moment(now).isAfter(pollDetails.pollEndDate)) {
            this.setState({
                donePoll: true
            })
        }
    }

    toggle = () => {
        this.setState({
            showCollapse: !this.state.showCollapse
        })
    }





    render() {
        let selection = this.state.currentSelection

        return (
            <div>
                <Card className="card-collapse">
                    <Card.Header className="text-white" style={{ backgroundColor: 'var(--primaryColor)' }}>{selection.selectionTitle}{this.state.showCollapse ? <FaMinus className="toggle-button" onClick={() => this.toggle()} /> : <FaPlus className="toggle-button" onClick={() => this.toggle()} />}</Card.Header>
                    <Collapse in={this.state.showCollapse}>
                        <Card.Body>
                            <span style={{ fontSize: '14px' }}>{MAXNUMBER_OF_CHOICES}</span> <br />
                            <b style={{ marginLeft: '30px' }}>{selection.numChoices}</b> <br />
                            <span style={{ marginTop: '30px' }}>{CHOICES}</span> <br />
                            {!isNullOrUndefined(selection.choiceListWithResult) && selection.choiceListWithResult.map((data, i) => {
                                return (
                                    <div key={i} style={{ marginTop: '10px' }}>
                                        <Row key={i} style={{ marginLeft: '0px' }}>
                                            <Form.Control value={data.pollSelectionChoiceModel.choiceLabel} data-item={i} name="choiceLabel" disabled={true} style={{ width: '30%' }}></Form.Control>
                                            <span className="vote-count"><b> {data.resultCount} {VOTES}</b></span>
                                        </Row>
                                    </div>
                                )
                            })}
                        </Card.Body>
                    </Collapse>
                </Card>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {

    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(PollSelectionResult);